import { Text, TextProps } from "@aws-amplify/ui-react";
import { theme } from "../../../theme";
import { PropsWithChildren } from "react";

export default function TextMuted(
  props: PropsWithChildren<Pick<TextProps, "style">> & { size?: "small" }
) {
  return (
    <Text
      style={props.style}
      color={theme.muted}
      {...(props.size ? { fontSize: "12px" } : undefined)}
    >
      {props.children}
    </Text>
  );
}
